export default async function setShouldRequestRenterTourFeedback({ state }, shouldRequestRenterTourFeedback) {
  state.set(['shouldRequestRenterTourFeedback'], shouldRequestRenterTourFeedback);
}
